import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { reduxForm, formPropTypes, Field } from 'redux-form';
import {
  Row,
  Col,
  FormGroup,
  Button,
} from 'react-bootstrap';

import { DateField } from '../../fields/index';
import EquipmentFilter from '../../fields/EquipmentFilter';
import { setDates, setEquipment } from '../actions';
import { createRenderer } from '../../reduxForm/utils';


const FORM_NAME = 'equipmentFilterPanelForm';

const propTypes = exact({
  setDatesAction: PropTypes.func.isRequired,
  setEquipmentAction: PropTypes.func.isRequired,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  equipment: PropTypes.object,
  initialValues: PropTypes.object,

  validate: PropTypes.func.isRequired,
  ...formPropTypes,
});

const validate = (values) => {
  const errors = [];

  const { startDate, endDate, equipment } = values;

  if (!equipment) {
    errors.equipment = 'Required';
  }

  if (!startDate) {
    errors.startDate = 'Required';
  }

  if (!endDate) {
    errors.endDate = 'Required';
  }

  if (startDate && endDate) {
    const sd = Date.parse(startDate);
    const ed = Date.parse(endDate);

    if (ed < sd) {
      errors.endDate = 'Invalid Date Range';
    }
  }
  return errors;
};

const RenderEquipment = createRenderer((input, label, { equipment }) => {
  return (
    <EquipmentFilter {...input} equipment={equipment} />
  );
});

const FilteringPanel = (props) => {
  const {
    handleSubmit,
    submitting,
    invalid,
    pristine,
  } = props;

  const formSubmit = (values) => {
    const { setDatesAction, setEquipmentAction } = props;
    const { startDate, endDate, equipment } = values;

    const isoStartDate = new Date(startDate).toISOString();
    const isoEndDate = new Date(endDate).toISOString();

    setDatesAction(isoStartDate, isoEndDate);
    setEquipmentAction(equipment);
  };

  return (
    <form onSubmit={handleSubmit(formSubmit)}>
      <Row>
        <Col md={12}>
          <FormGroup>
            <DateField
              name="startDate"
              label="Start Date"
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <FormGroup>
            <DateField
              name="endDate"
              label="End Date"
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <FormGroup>
            <Field
              name="equipment"
              type="select"
              label="Equipment Number"
              component={RenderEquipment}
            />
          </FormGroup>
        </Col>
      </Row>
      <Button
        bsStyle="primary"
        type="submit"
        disabled={(submitting || pristine || invalid)}
      >
        Submit
      </Button>
    </form>
  );
};


FilteringPanel.propTypes = propTypes;
FilteringPanel.defaultProps = {
  initialValues: {},
};

const withForm = reduxForm({
  form: FORM_NAME,
  enableReinitialize: true,
  validate,
});

const mapDispatchToProps = {
  setDatesAction: setDates,
  setEquipmentAction: setEquipment,
};

const withRedux = connect(null, mapDispatchToProps);

const enhance = compose(
  withRedux,
  withForm,
);

export default enhance(FilteringPanel);
